import React from 'react';
const tomos = [{
  n: '1',
  title: 'Crea Productos que tus Clientes Nunca Olvidan',
  desc: 'Transforma un objeto en un ritual capaz de crear recuerdos y hacer que el cliente quiera comprar antes de pensar en el precio.'
}, {
  n: '2',
  title: 'Diseña Aromas que Enamoran',
  desc: 'Combina aromas con intención para despertar calma, energía, lujo o nostalgia, creando colecciones con personalidad propia.'
}, {
  n: '3',
  title: 'Convierte Cada Compra en una Experiencia Premium',
  desc: 'Diseña un proceso de compra inolvidable con empaques, tarjetas de ritual y detalles sensoriales que elevan tu marca.'
}, {
  n: '4',
  title: 'Crea Colecciones que se Venden Solas',
  desc: 'Construye líneas completas por emociones, momentos del día y espacios del hogar para aumentar el ticket promedio.'
}, {
  n: '5',
  title: 'Haz que tus Clientes “Huelan” tus Productos Antes de Comprarlos',
  desc: 'Escribe descripciones y mensajes que permitan al cliente imaginar el aroma incluso antes de recibir el producto.'
}, {
  n: '6',
  title: 'Construye una Marca que Venda por Valor y No por Precio',
  desc: 'Posiciona tu marca como una experiencia premium y atrae clientes que valoran la calidad y compran sin pedir descuentos.'
}];
export function Tomos() {
  return <section className="w-full bg-[#efe7da] px-5 py-14" data-id="element-218" data-mp="3jgxhu4kyw4cx">
      <div className="mx-auto max-w-md" data-id="element-219" data-mp="3ofh4y8barm6v">
        <h2 className="text-center font-serif-display text-3xl font-bold leading-tight text-[#3b3350]" data-id="element-220" data-mp="3ogs5lz9g4dtr">
          ¿Qué encontrarás dentro?
        </h2>
        <p className="mt-3 text-center text-sm text-[#7a7288]" data-id="element-221" data-mp="19q5brxw8b7h">
          Todo organizado en 6 Tomos Premium para aplicar desde el primer día.
        </p>

        <div className="mt-8 space-y-4" data-id="element-222" data-mp="66qam0mx59xj">
          {tomos.map(t => <article key={t.n} className="relative overflow-hidden rounded-2xl bg-white p-5 shadow-sm ring-1 ring-[#e4dbcc]" data-id="element-223" data-mp="232xhwtm4gepo">
              <div className="flex items-start gap-4" data-id="element-224" data-mp="1zyzt99q05wcv">
                <div className="flex flex-col items-center" data-id="element-225" data-mp="201kvw0y4kgbo">
                  <span className="text-[10px] font-bold uppercase tracking-widest text-[#a99bc9]" data-id="element-226" data-mp="1vzhhb3g5svm6">
                    Tomo
                  </span>
                  <span className="font-serif-display text-4xl font-bold leading-none text-[#7c6aa8]" data-id="element-227" data-mp="24yuiz9y1kfwc">
                    {t.n}
                  </span>
                </div>
                <div className="flex-1" data-id="element-228" data-mp="2iwj48iw0tp1x">
                  <h3 className="font-serif-display text-lg font-semibold leading-snug text-[#3b3350]" data-id="element-229" data-mp="2exk3zbl8iggt">
                    {t.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#5a5266]" data-id="element-230" data-mp="2sqjf71dzhoik">{t.desc}</p>
                </div>
              </div>
            </article>)}
        </div>

        {/* Implementation tools */}
        <div className="mt-8 rounded-2xl bg-[#3b3350] p-6 text-white" data-id="element-231" data-mp="32k8lvxa8u8xf">
          <h3 className="font-serif-display text-xl font-semibold text-[#e6d3ae]" data-id="element-232" data-mp="2xpcvf1knntmf">
            Además, herramientas de implementación inmediata
          </h3>
          <ul className="mt-4 space-y-3 text-sm" data-id="element-233" data-mp="3lb6qq1z33m1a">
            <li className="flex gap-2" data-id="element-234" data-mp="3l8swtwg54fvb">
              <span className="text-[#c9b8ea]" data-id="element-235" data-mp="37bnkjepu2krm">✔</span>
              <span data-id="element-236" data-mp="37d8dx10evxnw"><span className="font-semibold" data-id="element-237" data-mp="37d8d4ysl7tmu">Mapas de Ritual por Producto</span> — diseña la experiencia completa, del primer contacto a la recompra.</span>
            </li>
            <li className="flex gap-2" data-id="element-238" data-mp="2xjrk3x09yik8">
              <span className="text-[#c9b8ea]" data-id="element-239" data-mp="32c14yymj8sfn">✔</span>
              <span data-id="element-240" data-mp="32cuda4153pzw"><span className="font-semibold" data-id="element-241" data-mp="32dlz4n4xq9cz">Worksheets de Implementación</span> — ejercicios prácticos al finalizar cada tomo.</span>
            </li>
            <li className="flex gap-2" data-id="element-242" data-mp="2tjhcyh0qxm3s">
              <span className="text-[#c9b8ea]" data-id="element-243" data-mp="2tkio0lhri8li">✔</span>
              <span data-id="element-244" data-mp="2emqeqb2t6gfr"><span className="font-semibold" data-id="element-245" data-mp="2elygeshtu4ls">Checklists Accionables</span> — mejora tu marca sin olvidar ningún detalle.</span>
            </li>
            <li className="flex gap-2" data-id="element-246" data-mp="2jl1o6kp6yoxg">
              <span className="text-[#c9b8ea]" data-id="element-247" data-mp="3mwh1xy89g19k">✔</span>
              <span data-id="element-248" data-mp="3mvxlyn267my6"><span className="font-semibold" data-id="element-249" data-mp="3mvxi2bz1v2sw">Banco de Fórmulas Olfativas con Intención</span> — combinaciones para despertar emociones específicas.</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}